import { Component, OnInit } from '@angular/core';

import { UiService } from '../shared/services/ui.service';

@Component({
    selector: 'app-help',
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {
    constructor(
        private uiSrv: UiService
    ) { }

    ngOnInit() {
        this.uiSrv.changeTitle("main.nav.links.help.shortLabel");
    }
}
